(() => {
  'use strict';
  if (customElements.get('pk-product-service-addons')) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  customElements.define('pk-product-service-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      try { this.config = JSON.parse(this.querySelector('[data-services-config]').textContent); } catch (_) { this.hidden = true; return; }
      this.ready = true;
      this.productInfo = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      this.form?.querySelectorAll('.pk-opening-gift--product').forEach(element => {
        if (!element.textContent.trim() && !element.children.length) element.hidden = true;
      });
      this.panel = this.querySelector('.pk-services-panel');
      this.error = this.querySelector('.pk-services-error');
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.config.currency || 'USD'}).format(cents / 100);
      const services = this.config.services.filter(p => p.variants.some(v => v.available && !v.requires_shipping));
      const find = handle => services.find(p => p.handle === handle);
      this.groups = [
        {key:'lamps', title:'Lamp offering', products:[find('jokhang-temple-lamp-offering-in-your-name'), find('lhasa-luphuk-butter-lamp-offering')], hint:'Choose a location & lamp count'},
        {key:'flags', title:'Prayer flag dedication', products:[find('tibetan-prayer-flag-hanging-service')], hint:'Choose your number of flags'},
        {key:'mani', title:'Mani stone dedication', products:[find('lhasa-mani-stone-placement')], hint:'Choose a mantra & finish'},
        {key:'kora', title:'Mount Kailash kora', products:[find('mount-kailash-kora-in-your-name')], hint:'One journey in your name'}
      ].map(g => ({...g, products:g.products.filter(Boolean)})).filter(g => g.products.length);
      if (!this.groups.length) { this.hidden = true; return; }
      this.groups.forEach(g => this.renderGroup(g));
      this.onChange = () => this.update();
      this.productInfo?.addEventListener('change', this.onChange);
      this.onSaleChange = () => { this.groups.forEach(g => this.refreshOptionPrices(g)); this.update(); };
      document.addEventListener('pk:opening-sale-state', this.onSaleChange);
      this.observer = new MutationObserver(() => this.update());
      const price = this.productInfo?.querySelector('[id^="price-"]');
      if (price) this.observer.observe(price, {childList:true,subtree:true});
      const gifts = this.productInfo?.querySelector('.pk-product-gifts-below-media');
      if (gifts && !gifts.dataset.defaultApplied) {
        gifts.open = matchMedia('(min-width:750px)').matches;
        gifts.dataset.defaultApplied = 'true';
      }
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.productInfo?.removeEventListener('change', this.onChange);
      document.removeEventListener('pk:opening-sale-state', this.onSaleChange);
      this.ready = false;
      this.querySelector('.pk-services-rows')?.replaceChildren();
    }
    discounted(product, variant) {
      const sale = window.PKOpeningSale;
      return sale?.active() && sale.eligible(product) ? sale.saleCents(variant.price) : Number(variant.price);
    }
    renderTotal(element, original, current, suffix = '') {
      const base = this.money(original) + suffix;
      element.classList.remove('pk-sale-amount');
      element.removeAttribute('data-pk-sale-price');
      element.removeAttribute('data-pk-base-text');
      if (current < original) {
        const old = document.createElement('s'), sale = document.createElement('strong');
        old.textContent = this.money(original);
        sale.textContent = this.money(current) + suffix;
        element.classList.add('pk-sale-amount');
        element.dataset.pkSalePrice = '';
        element.dataset.pkBaseText = base;
        element.replaceChildren(old, sale);
      } else element.textContent = this.money(current) + suffix;
    }
    selectedVariant(g) { return g.product?.variants.find(v => String(v.id) === g.variant?.value && v.available && !v.requires_shipping); }
    renderGroup(g) {
      const uid = `pk-service-${this.dataset.sectionId}-${g.key}`;
      g.row = document.createElement('article'); g.row.className = 'pk-service-choice'; g.row.dataset.service = g.key;
      g.row.innerHTML = `<label class="pk-service-choice__head"><input type="checkbox" aria-label="Add ${escape(g.title)}" aria-expanded="false" aria-controls="${uid}"><img src="${escape(g.products[0].image)}" alt="${escape(g.title)}" width="48" height="54" loading="lazy"><span><strong>${escape(g.title)}</strong><small>${escape(g.hint)}</small></span><span class="pk-service-choice__price"></span></label><div class="pk-service-choice__body" id="${uid}" hidden></div>`;
      this.querySelector('.pk-services-rows').append(g.row);
      g.check = g.row.querySelector('input'); g.body = g.row.querySelector('.pk-service-choice__body');
      if (g.products.length > 1) {
        const label = document.createElement('label'); label.htmlFor = `${uid}-place`; label.textContent = 'Offering location';
        g.place = document.createElement('select'); g.place.id = label.htmlFor;
        g.place.innerHTML = `<option value="">Choose a location</option>${g.products.map((p,i) => `<option value="${i}">${p.handle.startsWith('jokhang-') ? 'Jokhang Temple' : 'Lhasa Luphuk'}</option>`).join('')}`;
        g.body.append(label, g.place);
        g.place.addEventListener('change', () => this.renderOptions(g, g.place.value === '' ? null : g.products[Number(g.place.value)]));
      }
      g.options = document.createElement('div'); g.body.append(g.options);
      this.renderOptions(g, g.products.length === 1 ? g.products[0] : null);
      g.check.addEventListener('change', () => {
        g.body.hidden = !g.check.checked;
        g.check.setAttribute('aria-expanded', String(g.check.checked));
        this.error.hidden = true; this.update();
      });
    }
    renderOptions(g, product) {
      g.product = product; g.variant = null; g.options.replaceChildren();
      if (!product) { this.update(); return; }
      const uid = `pk-service-${this.dataset.sectionId}-${g.key}`;
      g.options.innerHTML = `<label for="${uid}-variant">${escape(product.optionName)}</label><select id="${uid}-variant" data-service-variant><option value="">Choose an option</option></select><label for="${uid}-name">Name for the dedication ${product.nameRequired ? '*' : '(optional now)'}</label><input id="${uid}-name" data-property="Dedication name" type="text" maxlength="120" autocomplete="off" ${product.nameRequired ? 'required' : ''}>${product.hasWish ? `<label for="${uid}-wish">Your wish (optional now)</label><textarea id="${uid}-wish" data-property="Wish" maxlength="2000" rows="3"></textarea>` : ''}<p>${product.hasWish ? 'You may also send these details by replying to your order confirmation. The 15-day completion period begins once both are received.' : 'Please enter the name to appear in your completion video.'}</p>${product.culturalImage ? '<p>Cultural imagery · Not an individual order record.</p>' : ''}<a href="${escape(product.url)}" target="_blank" rel="noopener">Service details & completion terms ↗</a>`;
      g.variant = g.options.querySelector('select');
      product.variants.forEach(v => { const option = document.createElement('option'); option.value = v.id; option.disabled = !v.available || v.requires_shipping; option.dataset.title = v.title; g.variant.append(option); });
      this.refreshOptionPrices(g);
      g.variant.addEventListener('change', () => { this.error.hidden = true; this.update(); });
      this.update();
    }
    refreshOptionPrices(g) {
      if (!g.variant) return;
      [...g.variant.options].slice(1).forEach(option => {
        const variant = g.product.variants.find(v => String(v.id) === option.value);
        const current = this.discounted(g.product, variant);
        const amounts = current < Number(variant.price) ? `${this.money(variant.price)} → ${this.money(current)}` : this.money(current);
        option.textContent = `${variant.title} — ${amounts}${option.disabled ? ' · Unavailable' : ''}`;
      });
    }
    update() {
      if (!this.groups) return;
      let selected = 0, pending = 0, subtotal = 0, originalSubtotal = 0;
      this.groups.forEach(g => {
        if (!g.check) return;
        const variant = this.selectedVariant(g);
        if (g.check.checked) {
          selected++;
          if (variant) { subtotal += this.discounted(g.product, variant); originalSubtotal += Number(variant.price); }
          else pending++;
        }
        const offers = g.products.flatMap(product => product.variants.filter(v => v.available && !v.requires_shipping).map(v => ({product, variant:v})));
        const offer = g.check.checked && variant ? {product:g.product, variant} : offers.sort((a,b) => this.discounted(a.product,a.variant)-this.discounted(b.product,b.variant))[0];
        const price = g.row.querySelector('.pk-service-choice__price');
        price.replaceChildren();
        const label = document.createElement('small'); label.textContent = g.check.checked && variant ? 'Selected' : 'from';
        const amount = document.createElement('span'); price.append(label, amount);
        this.renderTotal(amount, Number(offer.variant.price), this.discounted(offer.product, offer.variant));
      });
      this.querySelector('[data-services-count]').textContent = selected ? `${selected} service${selected > 1 ? 's' : ''} selected${pending ? ' · Choose options' : ''}` : 'No services selected';
      this.renderTotal(this.querySelector('[data-services-price]'), originalSubtotal, subtotal, pending ? ' + pending' : '');
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      const primary = this.config.product.variants.find(v => String(v.id) === variantId);
      this.hidden = !primary?.available;
      const quantity = Math.max(1, parseInt(new FormData(this.form).get('quantity'),10) || 1);
      const total = this.querySelector('[data-services-total]');
      if (primary) this.renderTotal(total, Number(primary.price) * quantity + originalSubtotal, this.discounted(this.config.product,primary) * quantity + subtotal, pending ? ' + pending' : '');
      else { total.textContent = 'Select a product option'; total.removeAttribute('data-pk-sale-price'); total.removeAttribute('data-pk-base-text'); total.classList.remove('pk-sale-amount'); }
      const submit = this.form?.querySelector('[name="add"] > span');
      if (submit) {
        if (!this.originalLabel) this.originalLabel = primary?.available ? submit.textContent.trim() : 'Add to bag';
        if (primary?.available && !this.form.querySelector('[name="add"]')?.disabled) submit.textContent = selected ? 'Add piece & services' : this.originalLabel;
      }
      this.form?.querySelectorAll('.shopify-payment-button').forEach(el => { el.hidden = selected > 0; });
      this.classList.toggle('has-services', selected > 0);
    }
    getItems() {
      const items = []; this.error.hidden = true;
      for (const g of this.groups.filter(g => g.check.checked)) {
        const variant = this.selectedVariant(g);
        if (!variant) return this.fail(`Please choose the options for ${g.title}.`, g, g.place && !g.place.value ? g.place : g.variant);
        const properties = {};
        for (const field of g.options.querySelectorAll('[data-property]')) {
          if (field.required && !field.value.trim()) return this.fail(`Please enter the dedication name for ${g.title}.`, g, field);
          if (field.value.trim()) properties[field.dataset.property] = field.value.trim();
        }
        items.push({id:variant.id,quantity:1,properties});
      }
      return items;
    }
    fail(message, group, field) {
      this.panel.open = true; group.body.hidden = false;
      this.error.hidden = false; this.error.textContent = message;
      field?.focus(); return null;
    }
  });
})();



